import * as API from '@/api';
import axios from 'axios';

const root = 'https://www.tainan-temple-tour.net';

// 全部文章都拿回來
export function getAllArticles() {
  // 定義有哪幾類別的文章
  const getAllArtworks = API.GET('/artworks?limit=1000');
  const getAllTemples = API.GET('/temples?limit=1000');
  const getAllAlbums = API.GET('/albums?limit=1000');
  const getAllThemes = API.GET('/themes?limit=1000');

  axios
    .all([getAllArtworks, getAllTemples, getAllAlbums, getAllThemes])
    .then(
      axios.spread((...responses) => {
        const artworks = responses[0].data.data;
        const temples = responses[1].data.data;
        const albums = responses[2].data.data;
        const themes = responses[3].data.data;
        const allArticles = [
          { articles: artworks, route: 'artwork' },
          { articles: temples, route: 'temple' },
          { articles: albums, route: 'album' },
          { articles: themes, route: 'theme' }
        ];

        // ! 想看文章總數就打開註解
        //const TOTAL_ARTICLES_LENGTH =
        // artworks.length + temples.length + albums.length + themes.length;
        // console.log('全部文章的數量：', TOTAL_ARTICLES_LENGTH);

        return allArticles;
      })
    )
    .then(allArticles => {
      // 整理成攤平的網址列表
      const allDynamicUrls = allArticles
        .map(categorizedArticles => {
          const urls = categorizedArticles.articles.map(article => {
            return `${root}/${categorizedArticles.route}/${article.id}`;
          });

          return urls;
        })
        .flat();

      // 產出完整的 SiteMap
      generateSitemap(allDynamicUrls);
    })
    .catch(errors => {
      console.log(errors);
    });
}

export function generateSitemap(allDynamicUrls = []) {
  // 建立一個 xml 檔案
  const xmlDoc = document.implementation.createDocument(null, 'sitemap');

  // urlset
  const urlsetTag = xmlDoc.createElement('urlset');
  urlsetTag.setAttribute(
    'xmlns',
    'http://www.sitemaps.org/schemas/sitemap/0.9'
  );
  urlsetTag.setAttribute(
    'xmlns:xsi',
    'http://www.w3.org/2001/XMLSchema-instance'
  );
  urlsetTag.setAttribute(
    'xsi:schemaLocation',
    'http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd'
  );

  // 靜態網址
  const staticUrls = [
    '',
    'artworks',
    'temples',
    'themes',
    'albums',
    'tags',
    'links',
    'searchinput',
    'register',
    'login',
    'favourite',
    'forgot-password',
    'reset-password',
    '404'
  ];

  const allStaticUrls = staticUrls.map(staticUrl => {
    return `${root}/${staticUrl}`;
  });

  // 結合靜態與動態網址
  const allUrls = [...allStaticUrls, ...allDynamicUrls];

  // 全部網址改成 xml 結構
  allUrls.forEach(url => {
    const urlTag = xmlDoc.createElement('url');
    const locTag = xmlDoc.createElement('loc');

    locTag.textContent = url;
    urlTag.appendChild(locTag);
    urlsetTag.appendChild(urlTag);
  });

  const divTag = xmlDoc.createElement('div');
  divTag.appendChild(urlsetTag);

  // ! 取得完整 xml 內容結構字串
  // console.log(divTag.innerHTML);
}
